var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-card");
/**
 * The main content for the `Card`. This adds some additional padding and removes
 * margin from `<p>` tags by default.
 */
export var CardContent = forwardRef(function CardContent(_a, ref) {
    var _b = _a.disablePadding, disablePadding = _b === void 0 ? false : _b, _c = _a.disableExtraPadding, disableExtraPadding = _c === void 0 ? false : _c, _d = _a.disableSecondaryColor, disableSecondaryColor = _d === void 0 ? false : _d, _e = _a.disableParagraphMargin, disableParagraphMargin = _e === void 0 ? false : _e, className = _a.className, children = _a.children, props = __rest(_a, ["disablePadding", "disableExtraPadding", "disableSecondaryColor", "disableParagraphMargin", "className", "children"]);
    return (_jsx("div", __assign({}, props, { ref: ref, className: cn(block("content", {
            padded: !disablePadding,
            "extra-padding": !disablePadding && !disableExtraPadding,
            "remove-margin": !disableParagraphMargin,
            secondary: !disableSecondaryColor,
        }), className) }, { children: children }), void 0));
});
//# sourceMappingURL=CardContent.js.map